window.GA4Events = (function () {
    function e(e, t) {
        window.dataLayer.push({ event: e, ...t });
    }
    function t(e, t, i) {
        let n = !0;
        return (
            t.forEach((t) => {
                if ("string" == typeof t)
                    (t in e && void 0 !== e[t] && null !== e[t] && "" !== e[t]) ||
                        (console.error(`GA4 ${i}: Missing required field '${t}'`, e), (n = !1));
                else if ("object" == typeof t) {
                    const { name: a, url: o, bannerName: r, type: c } = t;
                    (a in e && typeof e[a] === c && "" !== e[a] && void 0 !== e[a] && null !== e[a]) ||
                        (console.error(`GA4 ${i}: Field '${a}' must be of type ${c}`, e), (n = !1));
                }
            }),
            n
        );
    }
    function i(e, i) {
        if (!Array.isArray(e) || 0 === e.length)
            return console.error(`GA4 ${i}: 'items' must be a non-empty array`, e), !1;
        let n = !0;
        return (
            e.forEach((e, a) => {
                t(
                    e,
                    [
                        { name: "item_id", type: "string" },
                        { name: "item_name", type: "string" },
                        { name: "price", type: "number" },
                        { name: "quantity", type: "number" },
                    ],
                    `${i} (item[${a}])`
                ) || (n = !1);
            }),
            n
        );
    }
    return (
        (window.dataLayer = window.dataLayer || []),
        {
            trackEvent: e,
            viewItemList: function ({ item_list_id: t, item_list_name: i, items: n }) {
                window.dataLayer.push({ ecommerce: null });
                const a = n.map((e) => ({
                    item_id: e.item_id,
                    item_name: e.item_name,
                    coupon: e.coupon || "NA",
                    discount: e.discount || "NA",
                    index: e.index || "NA",
                    item_brand: e.item_brand || "NA",
                    item_category: e.item_category || "NA",
                    item_category2: e.item_category2 || "NA",
                    item_category3: e.item_category3 || "NA",
                    item_category4: e.item_category4 || "NA",
                    item_category5: e.item_category5 || "NA",
                    item_list_id: t,
                    item_list_name: i,
                    item_variant: e.item_variant || "NA",
                    price: e.price,
                    quantity: e.quantity,
                }));
                e("view_item_list", { ecommerce: { item_list_id: t, item_list_name: i, items: a } });
            },
            selectItem: function ({ item_list_id: t, item_list_name: i, items: n }) {
                window.dataLayer.push({ ecommerce: null });
                const a = n.map((e) => ({
                    item_id: e.item_id,
                    item_name: e.item_name,
                    coupon: e.coupon || "NA",
                    discount: e.discount || "NA",
                    index: e.index || "NA",
                    item_brand: e.item_brand || "NA",
                    item_category: e.item_category || "NA",
                    item_category2: e.item_category2 || "NA",
                    item_category3: e.item_category3 || "NA",
                    item_category4: e.item_category4 || "NA",
                    item_category5: e.item_category5 || "NA",
                    item_list_id: t,
                    item_list_name: i,
                    item_variant: e.item_variant || "NA",
                    price: e.price,
                    quantity: e.quantity,
                }));
                e("select_item", { ecommerce: { item_list_id: t, item_list_name: i, items: a } });
            },
            viewItem: function ({ currency: t, value: i, items: n }) {
                window.dataLayer.push({ ecommerce: null }),
                    e("view_item", {
                        ecommerce: {
                            currency: t,
                            value: i,
                            items: n.map((e) => ({
                                item_id: e.item_id,
                                item_name: e.item_name,
                                coupon: e.coupon || "NA",
                                discount: e.discount || "NA",
                                item_brand: e.item_brand || "NA",
                                item_category: e.item_category || "NA",
                                item_category2: e.item_category2 || "NA",
                                item_category3: e.item_category3 || "NA",
                                item_category4: e.item_category4 || "NA",
                                item_category5: e.item_category5 || "NA",
                                item_list_id: e.item_list_id || "NA",
                                item_list_name: e.item_list_name || "NA",
                                item_variant: e.item_variant || "NA",
                                price: e.price,
                                quantity: e.quantity,
                            })),
                        },
                    });
            },
            addToCart: function ({ currency: n, value: a, items: o }) {
                t(
                    { currency: n, value: a },
                    [
                        { name: "currency", type: "string" },
                        { name: "value", type: "number" },
                    ],
                    "addToCart"
                ) &&
                    i(o, "addToCart") &&
                    (window.dataLayer.push({ ecommerce: null }),
                    e("add_to_cart", {
                        ecommerce: {
                            currency: n,
                            value: a,
                            items: o.map((e) => ({
                                item_id: e.item_id,
                                item_name: e.item_name,
                                coupon: e.coupon || "NA",
                                discount: e.discount || "NA",
                                item_brand: e.item_brand || "NA",
                                item_category: e.item_category || "NA",
                                item_category2: e.item_category2 || "NA",
                                item_category3: e.item_category3 || "NA",
                                item_category4: e.item_category4 || "NA",
                                item_category5: e.item_category5 || "NA",
                                item_list_id: e.item_list_id || "NA",
                                item_list_name: e.item_list_name || "NA",
                                item_variant: e.item_variant || "NA",
                                price: e.price,
                                quantity: e.quantity,
                            })),
                        },
                    }));
            },
            viewCart: function ({ currency: t, value: i, items: n }) {
                e("view_cart", {
                    ecommerce: {
                        currency: t,
                        value: i,
                        items: n.map((e) => ({
                            item_id: e.item_id,
                            item_name: e.item_name,
                            coupon: e.coupon || void 0,
                            discount: e.discount || void 0,
                            item_brand: e.item_brand || void 0,
                            item_category: e.item_category || void 0,
                            item_category2: e.item_category2 || void 0,
                            item_category3: e.item_category3 || void 0,
                            item_category4: e.item_category4 || void 0,
                            item_category5: e.item_category5 || void 0,
                            item_list_id: e.item_list_id || void 0,
                            item_list_name: e.item_list_name || void 0,
                            item_variant: e.item_variant || void 0,
                            price: e.price,
                            quantity: e.quantity,
                        })),
                    },
                });
            },
            removeFromCart: function ({ currency: n, value: a, items: o }) {
                t(
                    { currency: n, value: a },
                    [
                        { name: "currency", type: "string" },
                        { name: "value", type: "number" },
                    ],
                    "removeFromCart"
                ) &&
                    i(o, "removeFromCart") &&
                    (window.dataLayer.push({ ecommerce: null }),
                    e("remove_from_cart", {
                        ecommerce: {
                            currency: n,
                            value: a,
                            items: o.map((e) => ({
                                item_id: e.item_id,
                                item_name: e.item_name,
                                coupon: e.coupon || void 0,
                                discount: e.discount || void 0,
                                item_brand: e.item_brand || void 0,
                                item_category: e.item_category || void 0,
                                item_category2: e.item_category2 || void 0,
                                item_category3: e.item_category3 || void 0,
                                item_category4: e.item_category4 || void 0,
                                item_category5: e.item_category5 || void 0,
                                item_list_id: e.item_list_id || void 0,
                                item_list_name: e.item_list_name || void 0,
                                item_variant: e.item_variant || void 0,
                                price: e.price,
                                quantity: e.quantity,
                            })),
                        },
                    }));
            },
            beginCheckout: function ({ coupon: n, currency: a, value: o, items: r }) {
                t(
                    { currency: a, value: o },
                    [
                        { name: "currency", type: "string" },
                        { name: "value", type: "number" },
                    ],
                    "beginCheckout"
                ) &&
                    i(r, "beginCheckout") &&
                    (window.dataLayer.push({ ecommerce: null }),
                    e("begin_checkout", {
                        ecommerce: {
                            coupon: n,
                            currency: a,
                            value: o,
                            items: r.map((e) => ({
                                item_id: e.item_id,
                                item_name: e.item_name,
                                coupon: e.coupon || void 0,
                                discount: e.discount || void 0,
                                item_brand: e.item_brand || void 0,
                                item_category: e.item_category || void 0,
                                item_category2: e.item_category2 || void 0,
                                item_category3: e.item_category3 || void 0,
                                item_category4: e.item_category4 || void 0,
                                item_category5: e.item_category5 || void 0,
                                item_list_id: e.item_list_id || void 0,
                                item_list_name: e.item_list_name || void 0,
                                item_variant: e.item_variant || void 0,
                                price: e.price,
                                quantity: e.quantity,
                            })),
                        },
                    }));
            },
            purchase: function ({
                transaction_id: n,
                value: a,
                tax: o,
                shipping: r,
                currency: c,
                coupon: m,
                affiliation: d,
                items: _,
            }) {
                t(
                    { transaction_id: n, value: a, currency: c },
                    [
                        { name: "transaction_id", type: "string" },
                        { name: "value", type: "number" },
                        { name: "currency", type: "string" },
                    ],
                    "purchase"
                ) &&
                    i(_, "purchase") &&
                    (window.dataLayer.push({ ecommerce: null }),
                    e("purchase", {
                        ecommerce: {
                            transaction_id: n,
                            value: a,
                            tax: o,
                            shipping: r,
                            currency: c,
                            coupon: m,
                            affiliation: d,
                            items: _.map((e) => ({
                                item_id: e.item_id,
                                item_name: e.item_name,
                                coupon: e.coupon || void 0,
                                discount: e.discount || void 0,
                                item_brand: e.item_brand || void 0,
                                item_category: e.item_category || void 0,
                                item_category2: e.item_category2 || void 0,
                                item_category3: e.item_category3 || void 0,
                                item_category4: e.item_category4 || void 0,
                                item_category5: e.item_category5 || void 0,
                                item_list_id: e.item_list_id || void 0,
                                item_list_name: e.item_list_name || void 0,
                                item_variant: e.item_variant || void 0,
                                price: e.price,
                                quantity: e.quantity,
                            })),
                        },
                    }));
            },
            viewPromotion: function ({
                promotion_id: n,
                promotion_name: a,
                creative_name: o,
                creative_slot: r,
                location_id: c,
                items: m,
            }) {
                t(
                    { promotion_id: n, promotion_name: a },
                    [
                        { name: "promotion_id", type: "string" },
                        { name: "promotion_name", type: "string" },
                    ],
                    "viewPromotion"
                ) &&
                    i(m, "viewPromotion") &&
                    ((window.dataLayer = window.dataLayer || []),
                    window.dataLayer.push({ ecommerce: null }),
                    e("view_promotion", {
                        ecommerce: {
                            promotion_id: n,
                            promotion_name: a,
                            creative_name: o,
                            creative_slot: r,
                            location_id: c,
                            items: m.map((e) => ({
                                item_id: e.item_id,
                                item_name: e.item_name,
                                coupon: e.coupon || void 0,
                                discount: e.discount || void 0,
                                item_brand: e.item_brand || void 0,
                                item_category: e.item_category || void 0,
                                item_category2: e.item_category2 || void 0,
                                item_category3: e.item_category3 || void 0,
                                item_category4: e.item_category4 || void 0,
                                item_category5: e.item_category5 || void 0,
                                item_list_id: e.item_list_id || void 0,
                                item_list_name: e.item_list_name || void 0,
                                item_variant: e.item_variant || void 0,
                                price: e.price,
                                quantity: e.quantity,
                            })),
                        },
                    }));
            },
            selectPromotion: function ({
                promotion_id: n,
                promotion_name: a,
                creative_name: o,
                creative_slot: r,
                location_id: c,
                items: m,
            }) {
                t(
                    { promotion_id: n, promotion_name: a },
                    [
                        { name: "promotion_id", type: "string" },
                        { name: "promotion_name", type: "string" },
                    ],
                    "selectPromotion"
                ) &&
                    i(m, "selectPromotion") &&
                    (window.dataLayer.push({ ecommerce: null }),
                    e("select_promotion", {
                        ecommerce: {
                            promotion_id: n,
                            promotion_name: a,
                            creative_name: o,
                            creative_slot: r,
                            location_id: c,
                            items: m.map((e) => ({
                                item_id: e.item_id,
                                item_name: e.item_name,
                                coupon: e.coupon || void 0,
                                discount: e.discount || void 0,
                                item_brand: e.item_brand || void 0,
                                item_category: e.item_category || void 0,
                                item_category2: e.item_category2 || void 0,
                                item_category3: e.item_category3 || void 0,
                                item_category4: e.item_category4 || void 0,
                                item_category5: e.item_category5 || void 0,
                                item_list_id: e.item_list_id || void 0,
                                item_list_name: e.item_list_name || void 0,
                                item_variant: e.item_variant || void 0,
                                price: e.price,
                                quantity: e.quantity,
                            })),
                        },
                    }));
            },
            headerBannerClick: function (e) {
                window.dataLayer.push({ event: "header_banner_click", ...e });
            },
            headerNavigation: function (e) {
                window.dataLayer.push({ event: "header_navigation", ...e });
            },
            footerNavigation: function (e) {
                t(
                    e,
                    [
                        { name: "menu_name", type: "string" },
                        { name: "click_text", type: "string" },
                        { name: "click_url", type: "string" },
                        { name: "menu_level", type: "string" },
                        { name: "menu_category", type: "string" },
                    ],
                    "footerNavigation"
                ) && window.dataLayer.push({ event: "footer_navigation", ...e });
            },
            hamburgerNavigation: function (e) {
                t(
                    e,
                    [
                        { name: "menu_name", type: "string" },
                        { name: "click_text", type: "string" },
                        { name: "click_url", type: "string" },
                        { name: "menu_level", type: "string" },
                        { name: "menu_category", type: "string" },
                    ],
                    "hamburgerNavigation"
                ) && window.dataLayer.push({ event: "hamburger_navigation", ...e });
            },
            breadcrumbNavigation: function (e) {
                window.dataLayer.push({ event: "breadcrumb_navigation", ...e });
            },
            shopByCategory: function (e) {
                window.dataLayer.push({ event: "shop_by_category", ...e });
            },
            shopByConcern: function (e) {
                window.dataLayer.push({ event: "shop_by_concern", ...e });
            },
            login: function (e) {
                t(
                    e,
                    [
                        { name: "method", type: "string" },
                        { name: "user_id", type: "string" },
                    ],
                    "login"
                ) && window.dataLayer.push({ event: "login", ...e });
            },
            sign_up: function (e) {
                t(
                    e,
                    [
                        { name: "method", type: "string" },
                        { name: "user_id", type: "string" },
                    ],
                    "sign_up"
                ) && window.dataLayer.push({ event: "sign_up", ...e });
            },
            socialInteraction: function (e) {
                t(
                    e,
                    [
                        { name: "platform", type: "string" },
                        { name: "page_section", type: "string" },
                    ],
                    "social_interaction"
                ) && window.dataLayer.push({ event: "social_interaction", ...e });
            },
            searchIconClick: function () {
                window.dataLayer.push({ event: "search_icon_click" });
            },
            popularSearches: function (e) {
                t(
                    e,
                    [
                        { name: "search_term", type: "string" },
                        { name: "click_text", type: "string" },
                        { name: "click_url", type: "string" },
                    ],
                    "popularSearches"
                ) && window.dataLayer.push({ event: "popular_searches", ...e });
            },
            searchRecentlyViewed: function (e) {
                window.dataLayer.push({ event: "search_recently_viewed", ...e });
            },
            searchProducts: function (e) {
                window.dataLayer.push({ event: "search_products", ...e });
            },
            searchBestSellers: function (e) {
                t(
                    e,
                    [
                        { name: "click_text", type: "string" },
                        { name: "click_url", type: "string" },
                    ],
                    "searchBestSellers"
                ) && window.dataLayer.push({ event: "search_best_sellers", ...e });
            },
            viewSearchResults: function (e) {
                t(e, [{ name: "search_term", type: "string" }], "viewSearchResults") &&
                    window.dataLayer.push({ event: "view_search_results", ...e });
            },
            heroBanner: function (e) {
                t(
                    e,
                    [
                        { name: "banner_title", type: "string" },
                        { name: "click_text", type: "string" },
                        { name: "click_url", type: "string" },
                    ],
                    "heroBanner"
                ) && window.dataLayer.push({ event: "hero_banner", ...e });
            },
            supportChatOpen: function () {
                window.dataLayer.push({ event: "support_chat_open" });
            },
            supportChatClick: function (e) {
                t(
                    e,
                    [
                        { name: "click_text", type: "string" },
                        { name: "click_url", type: "string" },
                    ],
                    "supportChatClick"
                ) && window.dataLayer.push({ event: "support_chat_click", ...e });
            },
            productCardSwipe: function (e) {
                window.dataLayer.push({ event: "product_card_swipe", ...e });
            },
            productVariantClick: function (e) {
                t(
                    e,
                    [
                        { name: "click_text", type: "string" },
                        { name: "product_title", type: "string" },
                    ],
                    "productVariantClick"
                ) && window.dataLayer.push({ event: "product_variant_click", ...e });
            },
            buildYourRegimeStep: function (e) {
                t(e, [{ name: "click_text", type: "string" }], "buildYourRegimeStep") &&
                    window.dataLayer.push({ event: "build_your_regime_step", ...e });
            },
            testimonialSwipe: function (e) {
                t(e, [{ name: "swipe_direction", type: "string" }], "testimonialSwipe") &&
                    window.dataLayer.push({ event: "testimonial_swipe", ...e });
            },
            blogOpen: function (e) {
                window.dataLayer.push({ event: "blog_open", ...e });
            },
            subscribe: function (e) {
                window.dataLayer.push({ event: "subscribe", ...e });
            },
            cpMainBannerSwipe: function (e) {
                window.dataLayer.push({ event: "cp_main_banner_swipe", ...e });
            },
            cpMainBannerClick: function (e) {
                window.dataLayer.push({ event: "cp_main_banner_click", ...e });
            },
            faq: function (e) {
                window.dataLayer.push({ event: "faq", ...e });
            },
            filterProducts: function (e) {
                window.dataLayer.push({ event: "filter_products", ...e });
            },
            sortProducts: function (e) {
                window.dataLayer.push({ event: "sort_products", ...e });
            },
            loadMoreProducts: function () {
                window.dataLayer.push({ event: "load_more_products" });
            },
            reviewInitiate: function () {
                window.dataLayer.push({ event: "review_initiate" });
            },
            reviewSubmit: function (e) {
                window.dataLayer.push({ event: "review_submit", ...e });
            },
            deliveryCheck: function (e) {
                window.dataLayer.push({ event: "delivery_check", ...e });
            },
            videoStart: function (e) {
                t(
                    e,
                    [
                        { name: "video_current_time", type: "number" },
                        { name: "video_duration", type: "number" },
                        { name: "video_percent", type: "number" },
                        { name: "video_provider", type: "string" },
                        { name: "video_title", type: "string" },
                        { name: "video_url", type: "string" },
                    ],
                    "videoStart"
                ) && window.dataLayer.push({ event: "video_start", ...e });
            },
            videoProgress: function (e) {
                t(
                    e,
                    [
                        { name: "video_current_time", type: "number" },
                        { name: "video_duration", type: "number" },
                        { name: "video_percent", type: "number" },
                        { name: "video_provider", type: "string" },
                        { name: "video_title", type: "string" },
                        { name: "video_url", type: "string" },
                    ],
                    "videoProgress"
                ) && window.dataLayer.push({ event: "video_progress", ...e });
            },
            videoComplete: function (e) {
                t(
                    e,
                    [
                        { name: "video_current_time", type: "number" },
                        { name: "video_duration", type: "number" },
                        { name: "video_percent", type: "number" },
                        { name: "video_provider", type: "string" },
                        { name: "video_title", type: "string" },
                        { name: "video_url", type: "string" },
                    ],
                    "videoComplete"
                ) && window.dataLayer.push({ event: "video_complete", ...e });
            },
            podcastStart: function (e) {
                t(
                    e,
                    [
                        { name: "podcast_current_time", type: "number" },
                        { name: "podcast_duration", type: "number" },
                        { name: "podcast_percent", type: "number" },
                        { name: "podcast_title", type: "string" },
                        { name: "podcast_url", type: "string" },
                    ],
                    "podcastStart"
                ) &&
                    ((window.dataLayer = window.dataLayer || []),
                    window.dataLayer.push({ event: "podcast_start", ...e }));
            },
            podcastProgress: function (e) {
                t(
                    e,
                    [
                        { name: "podcast_current_time", type: "number" },
                        { name: "podcast_duration", type: "number" },
                        { name: "podcast_percent", type: "number" },
                        { name: "podcast_title", type: "string" },
                        { name: "podcast_url", type: "string" },
                    ],
                    "podcastProgress"
                ) && window.dataLayer.push({ event: "podcast_progress", ...e });
            },
            podcastComplete: function (e) {
                t(
                    e,
                    [
                        { name: "podcast_current_time", type: "number" },
                        { name: "podcast_duration", type: "number" },
                        { name: "podcast_percent", type: "number" },
                        { name: "podcast_title", type: "string" },
                        { name: "podcast_url", type: "string" },
                    ],
                    "podcastComplete"
                ) && window.dataLayer.push({ event: "podcast_complete", ...e });
            },
            productImageSwipe: function (e) {
                window.dataLayer.push({ event: "product_image_swipe", ...e });
            },
            offerCopyClick: function (e) {
                window.dataLayer.push({ event: "offer_copy_click", ...e });
            },
            reviewClick: function (e) {
                window.dataLayer.push({ event: "review_click", ...e });
            },
            productImageModuleOpen: function (e) {
                t(
                    e,
                    [
                        { name: "image_position", type: "number" },
                        { name: "product_title", type: "string" },
                    ],
                    "productImageModuleOpen"
                ) && window.dataLayer.push({ event: "product_image_module_open", ...e });
            },
            instantAwardRedeemNow: function (e) {
                t(e, [{ name: "offer_text", type: "string" }], "instantAwardRedeemNow") &&
                    window.dataLayer.push({ event: "instant_award_redeem_now", ...e });
            },
            instantAwardSignUp: function (e) {
                t(e, [{ name: "offer_text", type: "string" }], "instantAwardSignUp") &&
                    window.dataLayer.push({ event: "instant_award_sign_up", ...e });
            },
            earnRewardSignup: function (e) {
                t(
                    e,
                    [
                        { name: "offer_text", type: "string" },
                        { name: "page_section", type: "string" },
                    ],
                    "earnRewardSignup"
                ) && window.dataLayer.push({ event: "earn_reward_signup", ...e });
            },
            earnRewardLogin: function (e) {
                t(
                    e,
                    [
                        { name: "offer_text", type: "string" },
                        { name: "page_section", type: "string" },
                    ],
                    "earnRewardLogin"
                ) && window.dataLayer.push({ event: "earn_reward_login", ...e });
            },
            bannerClick: function (e) {
                window.dataLayer.push({ event: "banner_click", ...e });
            },
            pdpStickyHeaderNavigation: function (e) {
                t(
                    e,
                    [
                        { name: "menu_name", type: "string" },
                        { name: "click_text", type: "string" },
                    ],
                    "pdpStickyHeaderNavigation"
                ) && window.dataLayer.push({ event: "pdp_sticky_header_navigation", ...e });
            },
            pdpScrollUpClick: function () {
                window.dataLayer.push({ event: "pdp_scroll_up_click" });
            },
            shopNow: function (e) {
                t(
                    e,
                    [
                        { name: "click_text", type: "string" },
                        { name: "click_url", type: "string" },
                    ],
                    "shopNow"
                ) && window.dataLayer.push({ event: "shop_now", ...e });
            },
            downloadAppGooglePlay: function () {
                window.dataLayer.push({ event: "download_app_google_play" });
            },
            downloadAppAppleStore: function () {
                window.dataLayer.push({ event: "download_app_apple_store" });
            },
            productVideoSwipe: function (e) {
                t(
                    e,
                    [
                        { name: "swipe_direction", type: "string" },
                        { name: "image_position", type: "number" },
                        { name: "product_title", type: "string" },
                    ],
                    "productVideoSwipe"
                ) && window.dataLayer.push({ event: "product_video_swipe", ...e });
            },
            downloadNowBannerClick: function (e) {
                t(
                    e,
                    [
                        { name: "click_text", type: "string" },
                        { name: "click_url", type: "string" },
                        { name: "banner_title", type: "string" },
                    ],
                    "downloadNowBannerClick"
                ) && window.dataLayer.push({ event: "download_now_banner_click", ...e });
            },
            claimNowOvernightBook: function () {
                window.dataLayer.push({ event: "claim_now_overnight_book" });
            },
            submitFormOvernightBook: function () {
                window.dataLayer.push({ event: "submit_form_overnight_book" });
            },
            gratitudeSectionInteractions: function (e) {
                t(e, [{ name: "click_text", type: "string" }], "gratitudeSectionInteractions") &&
                    window.dataLayer.push({ event: "gratitude_section_interactions", ...e });
            },
            productVideoStoryOpen: function (e) {
                t(
                    e,
                    [
                        { name: "click_text", type: "string" },
                        { name: "product_title", type: "string" },
                    ],
                    "productVideoStoryOpen"
                ) && window.dataLayer.push({ event: "product_video_story_open", ...e });
            },
            productVideoStorySwipe: function (e) {
                t(
                    e,
                    [
                        { name: "click_text", type: "string" },
                        { name: "product_title", type: "string" },
                    ],
                    "productVideoStorySwipe"
                ) && window.dataLayer.push({ event: "product_video_story_swipe", ...e });
            },
            productVideoTileOpen: function (e) {
                window.dataLayer.push({ event: "product_video_tile_open", ...e });
            },
            productVideoTileSwipe: function (e) {
                window.dataLayer.push({ event: "product_video_tile_swipe", ...e });
            },
            productVideoTileLike: function (e) {
                t(
                    e,
                    [
                        { name: "click_text", type: "string" },
                        { name: "product_title", type: "string" },
                    ],
                    "productVideoTileLike"
                ) && window.dataLayer.push({ event: "product_video_tile_like", ...e });
            },
            productVideoTileShare: function (e) {
                window.dataLayer.push({ event: "product_video_tile_share", ...e });
            },
            productVideoTileMinimize: function (e) {
                window.dataLayer.push({ event: "product_video_tile_minimize", ...e });
            },
            applyCoupon: function (e) {
                t(
                    e,
                    [
                        { name: "cart_value", type: "number" },
                        { name: "user_id", type: "string" },
                        { name: "discounted_cart_value", type: "number" },
                    ],
                    "applyCoupon"
                ) && window.dataLayer.push({ event: "apply_coupon", ...e });
            },
            removeCoupon: function (e) {
                t(
                    e,
                    [
                        { name: "cart_value", type: "number" },
                        { name: "user_id", type: "string" },
                        { name: "discounted_cart_value", type: "number" },
                    ],
                    "removeCoupon"
                ) && window.dataLayer.push({ event: "remove_coupon", ...e });
            },
            productImageThumbnailClick: function (e) {
                window.dataLayer.push({ event: "product_image_thumnail_click", ...e });
            },
            productsInBundle: function (e) {
                t(
                    e,
                    [
                        { name: "action_type", type: "string" },
                        { name: "product_title", type: "string" },
                    ],
                    "productsInBundle"
                ) && window.dataLayer.push({ event: "products_in_bundle", ...e });
            },
            productDetailNavigation: function (e) {
                t(
                    e,
                    [
                        { name: "click_text", type: "string" },
                        { name: "page_section", type: "string" },
                    ],
                    "productDetailNavigation"
                ) && window.dataLayer.push({ event: "product_detail_navigation", ...e });
            },
            productDetailCardSwipe: function (e) {
                t(
                    e,
                    [
                        { name: "page_section", type: "string" },
                        { name: "swipe_direction", type: "string" },
                        { name: "card_position", type: "number" },
                    ],
                    "productDetailCardSwipe"
                ) && window.dataLayer.push({ event: "product_detail_card_swipe", ...e });
            },
            bannerView: function (e) {
                t(
                    e,
                    [
                        { name: "click_text", type: "string" },
                        { name: "click_url", type: "string" },
                        { name: "page_section", type: "string" },
                        { name: "banner_title", type: "string" },
                    ],
                    "bannerView"
                ) && window.dataLayer.push({ event: "banner_view", ...e });
            },
        }
    );
})();
